import * as React from "react";
import { AccessLogsTable } from "../../component/AccessLogsTable";

export default function AccessLogsPage() {
  return (
    <>
      <AccessLogsTable />
    </>
  );
}